exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-btn-wrapper{position:relative;display:inline-block}.upload-btn-wrapper input[type=\"file\"]{font-size:100px;position:absolute;left:0;top:0;opacity:0;width:100%;height:100%;cursor:pointer;border-radius:15px !important}.upload-btn-wrapper .fileUpload{border:1px solid var(--text-light-blue);background:#fff;border-radius:15px !important;overflow:hidden;padding:6px 14px;position:relative;text-align:center;width:auto}.upload-btn-wrapper .fileUpload>input{z-index:1}.upload-btn-wrapper .fileUpload>span{z-index:2}.upload-btn-wrapper .fileUpload>span,.upload-btn-wrapper .fileUpload>span>i{cursor:pointer}.upload-btn-wrapper .onHover:hover,.upload-btn-wrapper .onHover:active,.upload-btn-wrapper .onHover:focus{background:var(--text-light-blue);color:#fff}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/buttons/uploadFileButton/uploadFileButton.scss
// module id = 716
// module chunks = 0